// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Korjaa marginin joka kasvattaa data-tablen rivien korkeutta */\n.v-input--selection-controls[data-v-292d7176] {\n  margin: 0 0px -16px -4px;\n}", ""]);
// Exports
module.exports = exports;
